module.exports = __webpack_public_path__ + "img/star-half-alt.4e7de533.svg";